import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextAreaField from '../../FormsElements/TextAreaField';
import { handleSave } from '../../IdentificationsTable';
import EventButton from '../../Buttons/EventButton';

function SystemState({ srm, editItem }) {
  console.log('SrmPre', srm);
  const [formData, setFormData] = useState({
    description: '',
    reportedBy: '',
    incidentId: 0,
    date: new Date().toISOString(),
    actionId: 0,

  });

  useEffect(() => {
    if (editItem) {
      setFormData({
        actionId: editItem.id ? editItem.id : 0,
        incidentId: srm ? srm.id : 0,
        description: editItem.description ? editItem.description : '',
      });
    } else {
      setFormData({
        description: '',
        reportedBy: '',
        incidentId: srm ? srm.id : 0,
        date: new Date().toISOString(),
      });
    }
  }, [editItem, srm]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    console.log('formData', formData);
    console.log('Id', typeof formData.incidentId);
    if (editItem) {
      const method = 'PATCH';
      await handleSave(`occurrences-data/${formData.incidentId}/update-preliminary-actions`, formData, method);
    } else {
      const method = 'POST';
      await handleSave('occurrences-data/actions-taken/', formData, method);
    }
  };

  return (
    <div className="relative p-4 w-full max-w-2xl max-h-full">
      <TextAreaField
        label="Preliminary Action"
        name="description"
        value={formData.description}
        onChange={handleChange}
        type="text"
        row={6}
        col={10}
      />
      {!editItem && (
        <TextAreaField
          label="Reported By"
          name="reportedBy"
          value={formData.actionReportedBy}
          onChange={handleChange}
          type="text"
          row={1}
          col={10}
        />
      )}
      <EventButton
        onSubmit={handleSubmit}
        linktext={editItem ? 'Edit' : 'Add'}
      />
    </div>
  );
}

SystemState.propTypes = {
  editItem: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    reportedBy: PropTypes.string,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  srm: PropTypes.object.isRequired,
};

SystemState.defaultProps = {
  editItem: null,
  // srm: null,
};
export default SystemState;
